import { useNavigate } from "react-router-dom";
import seriesStore from "../stores/seriesStore.js";
import statusStore from "../stores/statusStore.js";
import seasonStore from "../stores/seasonStore.js";
import episodeStore from "../stores/episodeStore.js";
import { filterByStatus } from "../utils/filterByStatus.js";

export default function NavigationBar({ selectedShow, setSelectedShow, selectedSeriesList, setSelectedSeriesList
  , activeHeader, setActiveHeader
 }) {

    const navigate = useNavigate();

    const serStore = seriesStore();
    const staStore = statusStore();
    const epStore = episodeStore();

    const { filteredSeries: startedSeries, filteredSeasons: startedSeasons } =
      filterByStatus(staStore.status, serStore.series, "Started");
    
    const { filteredSeries: toWatchSeries, filteredSeasons: toWatchSeasons } =
      filterByStatus(staStore.status, serStore.series, "To Watch");
  
    const { filteredSeries: comingSoonSeries, filteredSeasons: comingSoonSeasons } =
      filterByStatus(staStore.status, serStore.series, "Finished what's available");
  
    const { filteredSeries: stoppedSeries, filteredSeasons: stoppedSeasons } =
      filterByStatus(staStore.status, serStore.series, "Stopped");
  
    const { filteredSeries: finishedSeries, filteredSeasons: finishedSeasons } =
      filterByStatus(staStore.status, serStore.series, "Finished");

    return (
      <div>
        <div class="leftPanel">   

          <p class="navSectionHeader" className={`navSectionHeader ${
              activeHeader === "Calendar" ? "active" : ""
            }`} onClick={() => {
              navigate("/", {  state: {
                                    selectedShow: null,
                                    selectedSeriesList: null,
                                    activeHeader: "Calendar"
                                } });
            }}>Calendar</p>

          <p class="navSectionHeader" className={`navSectionHeader ${
            activeHeader === "Started" ? "active" : ""
           }`} onClick={() => {
            navigate("/", {  state: {
                                    selectedShow: null,
                                    selectedSeriesList: startedSeries,
                                    activeHeader: "Started"
                                } });
          }}>Started • {startedSeries.length}</p>
          {startedSeries.slice(0,5).map((s) => (
              <div className={`watching-item ${
                activeHeader == s._id ? "active" : ""
              }`} key={s._id} onClick={() => {
                            navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                            }}>
                {s.title}
              </div>
          ))}
          
          <p class="navSectionHeader" className={`navSectionHeader ${
            activeHeader === "To Watch" ? "active" : ""
           }`} onClick={() => {
            navigate("/", {  state: {
                                    selectedShow: null,
                                    selectedSeriesList: toWatchSeries,
                                    activeHeader: "To Watch"
                                } });
          }}>To Watch • {toWatchSeries.length}</p>
          {toWatchSeries.slice(0,5).map((s) => (
              <div className={`watching-item ${
                activeHeader == s._id ? "active" : ""
              }`} key={s._id} onClick={() => {
                            navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                            }}>
                {s.title}
              </div>
          ))}

          <p class="navSectionHeader" className={`navSectionHeader ${
            activeHeader === "Upcoming" ? "active" : ""
           }`} onClick={() => {
            navigate("/", {  state: {
                                    selectedShow: null,
                                    selectedSeriesList: comingSoonSeries,
                                    activeHeader: "Upcoming"
                                } });
          }}>Upcoming • {comingSoonSeries.length}</p>
          {comingSoonSeries.slice(0,5).map((s) => (
              <div className={`watching-item ${
                activeHeader == s._id ? "active" : ""
              }`} key={s._id} onClick={() => {
                            navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                            }}>
                {s.title}
              </div>
          ))}

          <p class="navSectionHeader" className={`navSectionHeader ${
            activeHeader === "Finished" ? "active" : ""
           }`} onClick={() => {
           navigate("/", {  state: {
                                    selectedShow: null,
                                    selectedSeriesList: finishedSeries,
                                    activeHeader: "Finished"
                                } });
          }}>Finished • {finishedSeries.length}</p>
          {finishedSeries.slice(0,5).map((s) => (
              <div className={`watching-item ${
                activeHeader == s._id ? "active" : ""
              }`} key={s._id} onClick={() => {
                            navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                            }}>
                {s.title}
              </div>
          ))}

          <p class="navSectionHeader" className={`navSectionHeader ${
            activeHeader === "Stopped" ? "active" : ""
           }`} onClick={() => {
           navigate("/", {  state: {
                                    selectedShow: null,
                                    selectedSeriesList: stoppedSeries,
                                    activeHeader: "Stopped"
                                } });
          }}>Stopped • {stoppedSeries.length}</p>
          {stoppedSeries.slice(0,5).map((s) => (
              <div className={`watching-item ${
                activeHeader == s._id ? "active" : ""
              }`} key={s._id} onClick={() => {
                            navigate("/series", {  state: {
                                    selectedShow: s,
                                    selectedSeriesList: null,
                                    activeHeader: s._id
                                } });
                            }}>
                {s.title}
              </div>
          ))}

        </div>
      </div>
    )
}